export default __webpack_public_path__ + "static/media/profilePic.b83bbe33.png";